// Google Analytics 工具函数

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

// 追踪页面浏览
export const trackPageView = (page_title: string, page_location?: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'G-5WTV3QDZPN', {
      page_title,
      page_location: page_location || window.location.href,
    });
  }
};

// 追踪自定义事件
export const trackEvent = (
  action: string,
  category: string,
  label?: string,
  value?: number
) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// 追踪封面生成事件
export const trackCoverGeneration = (style: string, success: boolean) => {
  trackEvent(
    success ? 'cover_generated' : 'cover_generation_failed',
    'cover_generator',
    style
  );
};

// 追踪论文分析事件
export const trackPaperAnalysis = (analysisType: string, success: boolean) => {
  trackEvent(
    success ? 'paper_analyzed' : 'paper_analysis_failed',
    'paper_analyzer',
    analysisType
  );
};

// 追踪用户注册
export const trackUserSignup = (method: string) => {
  trackEvent('sign_up', 'user_engagement', method);
};

// 追踪用户登录
export const trackUserLogin = (method: string) => {
  trackEvent('login', 'user_engagement', method);
};

// 追踪积分购买
export const trackCreditPurchase = (amount: number, package_type: string) => {
  trackEvent('purchase', 'ecommerce', package_type, amount);
};

// 追踪下载事件
export const trackDownload = (file_type: string, source: string) => {
  trackEvent('download', 'engagement', `${file_type}_from_${source}`);
};
